<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Reverso pagos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta corriente</span>
      <span> /</span>
      <span>Reverso pagos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<app-reverso-pagos-cabecera 
  [canAddReversoPago]="canAddReversoPago"
  (onSearch)="onSearch($event)" 
  (onSearchAll)="onSearchAll()">
</app-reverso-pagos-cabecera>

<app-reverso-pagos-detalles></app-reverso-pagos-detalles>